import { render } from "./EpisodeHint.vue?vue&type=template&id=f38861cc"
import script from "./EpisodeHint.vue?vue&type=script&lang=js"
export * from "./EpisodeHint.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__